exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-with-close-button__header{align-items:center;display:flex;justify-content:center;padding:15px;position:relative}.dialog-with-close-button__heading{font-size:16px;font-size:1rem;font-weight:500}.dialog-with-close-button__close-button{cursor:pointer;padding:10px;position:absolute;right:0;top:0}\n", ""]);

// exports
exports.locals = {
	"dialog-with-close-button__header": "dialog-with-close-button__header",
	"dialog-with-close-button__heading": "dialog-with-close-button__heading",
	"dialog-with-close-button__close-button": "dialog-with-close-button__close-button"
};